import getEffectiveUsage from '../getEffectiveUsage';
import getUnitBaselines from '../getUnitBaselines';

import type { GetPartUnitWear } from './types';

const NO_USAGE = 0;

const NO_REMAINING = 0;

const PERCENT_MULTIPLIER = 100;

const getPartUnitWear: GetPartUnitWear = ({ counters, logs, part }) => {
    const {
        effectiveIntervalUnit: intervalUnit,
        effectiveIntervalValue: intervalValue,
        partType,
        unitCount
    } = part;

    const currentUsage = getEffectiveUsage({ counters, intervalUnit });

    const baselines = getUnitBaselines({ intervalUnit, logs, partType, unitCount });

    if (currentUsage === null || intervalValue <= NO_USAGE) {
        return baselines.map(({ unitIndex }) => ({
            intervalUnit,
            intervalValue,
            partType,
            percentRemaining: null,
            remaining: null,
            status: 'NOT_CONFIGURED',
            unitIndex,
            usage: null
        }));
    }

    return baselines.map(({ baseline, unitIndex }) => {
        const usage = Math.max(NO_USAGE, currentUsage - baseline);
        const remaining = Math.max(NO_REMAINING, intervalValue - usage);

        return {
            intervalUnit,
            intervalValue,
            partType,
            percentRemaining: Math.round((remaining / intervalValue) * PERCENT_MULTIPLIER),
            remaining,
            status: remaining === NO_REMAINING ? 'DUE' : 'OK',
            unitIndex,
            usage
        };
    });
};

export default getPartUnitWear;
